export default {
  nav: {
    tags: 'Dispositivos',
    map: 'Mapa',
    alerts: 'Alertas',
    account: 'Conta',
    aria: 'Navegação principal',
  },
  offline_banner: 'Sem conexão — exibindo a última informação recebida.',
  update_available: 'Nova versão disponível.',
  update_now: 'Atualizar',
  login_tagline: 'Localize o que importa.',
  login_subtitle: 'Entre para acompanhar seus dispositivos.',
  continue_google: 'Continuar com Google',
  account_title: 'Conta',
  current_account: 'Conta atual',
  switch_account: 'Trocar de conta',
  install_title: 'Instalar LOCZI',
  install_hint: 'Acesso rápido na tela inicial',
  push_title: 'Notificações',
  push_unsupported: 'Não suportado neste navegador — o restante do app continua normal',
  push_granted: 'Ativadas neste dispositivo',
  push_denied: 'Bloqueadas pelo navegador',
  push_prompt: 'Receba avisos quando algo acontecer',
  orders_title: 'Pedidos',
  orders_denied: 'Sem permissão para ver pedidos.',
  orders_empty: 'Nenhum pedido ainda.',
  order_label: 'Pedido {id}',
  subscription_title: 'Assinatura',
  renews_at: 'Renova em {date}',
  fix_in_web: 'Regularizar no aplicativo completo →',
  no_subscription: 'Nenhuma assinatura ativa.',
  open_full: 'Abrir versão completa',
  open_full_hint: 'Filtros avançados, cercas e gestão no Web',
  help: 'Ajuda',
  logout: 'Sair',
  select_hint: 'Selecionar',
  empty_first_title: 'Seu primeiro localizador começa por aqui.',
  empty_first_manage: 'Ative seu localizador para começar a acompanhar.',
  empty_first_viewer: 'Fale com o administrador da sua conta para ativar um localizador.',
  activate_mine: 'Ativar meu localizador',
  empty_filtered: 'Nenhum dispositivo corresponde aos filtros.',
  search_tags: 'Buscar por nome ou código',
  tag_unavailable: 'Este conteúdo não está mais disponível para você.',
  select_hint_body: 'Fale com o administrador da sua conta.',
}
